export var createQueryParams = function (vals) {
    return Object.entries(vals)
        .filter(function (_a) {
        var v = _a[1];
        return v !== null && v !== undefined;
    })
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        return (v ? "".concat(k, "=").concat(v) : '');
    })
        .join('&');
};
